import {ChangeDetectorRef, Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {environment} from "../../../../../environments/environment";
import {Vapor} from "../../../Vapor";

@Component({
  selector: 'app-inline-file-upload',
  templateUrl: './inline-file-upload.component.html',
  styleUrls: ['./inline-file-upload.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InlineFileUploadComponent),
      multi: true
    }
  ]
})
export class InlineFileUploadComponent implements OnInit, ControlValueAccessor {

  @Input() type: 'document' | "image";
  @Input() existingURL: string | undefined;

  preview: string;
  fileName: string;

  writeFile: any;

  constructor(public ref: ChangeDetectorRef, private vapor: Vapor) {
    if(this.existingURL){
      this.preview = this.existingURL;
    }
  }

  ngOnInit(): void {
    if(this.existingURL){
      if(this.type === 'image'){
        this.preview = this.existingURL;
      }else{
        this.fileName = this.existingURL;
      }
    }
  }

  removeDoc(){
    this.writeFile(null);
    this.fileName = '';
    this.ref.detectChanges();
  }

  onFileInput(data: any){

    const reader = new FileReader();
    if(data.target.files && data.target.files.length) {
      const [file] = data.target.files;

      reader.readAsDataURL(file);
      reader.onload = () => {
        if(this.type === 'image'){
          this.preview = reader.result as string;
          this.ref.detectChanges()
        }else{
          this.fileName = file.name;
          this.ref.detectChanges()
        }
        this.writeFile(file);
      };

    }
  }

  registerOnChange(fn: any): void {
    this.writeFile = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(obj: any): void {

  }

}
